export default __webpack_public_path__ + "static/media/Levitate D7.4 Long term impacts of CCAM on freight transport.4a810d62.pdf";